<template>
  <div @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <main>
      <div id="container">
        <div id="content">
          <div class="title">
            <h2>よくある質問</h2>
          </div>
          <!-- =======
              質問
              ======== -->
          <ul>
            <li class="input_list" @click="selectOpenItem()">
              <h3 v-bind:class="{Q_open: isOpenItem, Q_close: !isOpenItem}">Q.&nbsp;商品仕様について</h3>
              <div v-show="isOpenItem">
                  <h4>A.</h4>
                  <p>商品の仕様は商品ページに記載されております。お確かめ下さい。</p>
                  <p> 掲載していない仕様に関しましても、ご相談承ります。 <router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご連絡ください。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenFiller()">
              <h3 v-bind:class="{Q_open: isOpenFiller, Q_close: !isOpenFiller}">Q.&nbsp;フィラーについて</h3>
              <div v-show="isOpenFiller">
                  <h4>A.</h4>
                  <p>フィラーのカラーはキャビネット柄と同色です。<br>
                  入力サイズに応じた既製品が付属されますので、<span class="red">必要に応じて現場で加工</span>をして下さい。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenDelivery()">
              <h3 v-bind:class="{Q_open: isOpenDelivery, Q_close: !isOpenDelivery}">Q.&nbsp;商品のお届けについて</h3>
              <div v-show="isOpenDelivery">
                <h4>A.</h4>
                <p>商品の製作にお日にちをいただいております。</p>
                <p>工場出荷目安は以下の通りです。</p>
                <ul>
                  <li>・フロート収納：10営業日～</li>
                  <li>・食器棚：16営業日</li>
                  <li>・玄関収納：11営業日</li>
                  <li>・棚板：10営業日</li>
                  <li>・カウンター下収納：10営業日</li>
                  <li>・カウンター：15営業日</li>
                  <li>・サイドボード：11営業日～</li>
                  <li>・テレビボード：11営業日</li>
                </ul>
                <p>※詳細なお届け日の日程はカートに追加後、購入画面より選択ください。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenDeliImposible()">
              <h3 v-bind:class="{Q_open: isOpenDeliImposible, Q_close: !isOpenDeliImposible}">Q.&nbsp;納品に調整が必要な地域について</h3>
              <div v-show="isOpenDeliImposible">
                <h4>A.</h4>
                <p>恐れ入りますが、下記地域への納品は別途調整させていただきます。</p>
                <p><router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご希望の商品と納品先のご住所をご連絡ください。</p>
                <p class="under_text">配送不可地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenPayment()">
              <h3 v-bind:class="{Q_open: isOpenPayment, Q_close: !isOpenPayment}">Q.&nbsp;購入の流れ・決済について</h3>
              <div v-show="isOpenPayment">
                <h4>A.</h4>
                <p>商品の寸法・色柄を決定し、「図面/見積り」ボタンを押し、図面/見積りを確認し後「注文する」からご注文に進むことができます。<br>
                お支払い方法を選択し、ご指定の方法で決済を行なってください。<br>
                商品の決済はクレジットカード決済、銀行振込のいずれかでのみ承っております。<br>
                入金確認後、製造を開始いたします。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenSetting()">
              <h3 v-bind:class="{Q_open: isOpenSetting, Q_close: !isOpenSetting}">Q.&nbsp;設置方法について</h3>
              <div v-show="isOpenSetting">
                  <h4>A.</h4>
                  <p>各シリーズの商品ページから設置説明書をダウンロードし、設置説明書に従って正しく取り付けて下さい。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenGuarantee()">
              <h3 v-bind:class="{Q_open: isOpenGuarantee, Q_close: !isOpenGuarantee}">Q.&nbsp;商品の保証について</h3>
              <div v-show="isOpenGuarantee">
                <h4>A.</h4>
                <p>保証期間
                対象製品の保証期間は、貴社のご指定場所に納入後1年間とします。
                </p>
                <p>保証内容
                保証期間内に、通常使用範囲で発生した故障については無償で代替品との交換または修理をさせていただきます。
                尚、取付設置時の不具合によって生じた破損につきましては、弊社では一切の責任を負いかねます。
                保証期間内でも次の場合には原則「有料」にさせていただきます。</p>
                <ul class="small_p">
                  <li>・使用 上の故意・過失または不当な修理や改造による故障及び損傷</li>
                  <li>・消耗部品の取替え や修理</li>
                  <li>・お買い上げ後の取付場所の移設、輸送、落下等による故障及び損傷</li>
                  <li>・火災 、地震、 水害、落雷、その他天災地変及び公害、塩害、ガス害（硫化ガス等）等による故障及び損傷</li>
                  <li>・車両、船舶等に搭載された場合に 生ずる故障及び損傷</li>
                  <li>・仕上げの傷等で、お引き渡し時に申し出がなかったもの</li>
                  <li>・瑕疵によら ない自然の磨耗、さび、かび、変 質、変色、その他類似の事由による場合</li>
                  <li>・維持管理の不備による水漏れ、膨れ、汚れ、さび、給水管、排水管の詰まり 等の不具合</li>
                  <li>・第三者による管理上、メンテナンス上等の不備に起因する不具合</li>
                  <li>・犬・猫・鳥・鼠等の小動物や虫等の行為に起因する故障及び損傷</li>
                  <li>・組立設置説明書に 記載された方法以外の設置内容に起因する損傷や 故障</li>
                  <li>・建築躯体の変形等対象商品本体以外の不具合に起因する故障及び損傷</li>
                  <li>・異常電圧や指定外の燃料 ・電源（電圧・周波数）の使用及び異常水質による故障及び損傷</li>
                  <li>・契約時、 実用化されていた技術では予防することが不可能な現象またはこれが原因で生じ た事故による場合</li>
                  <li>・保証期間経過後に申し出があったもの、または保証該当事項の発生後、速やか に申し出がなかったもの</li>
                  <li>・一般家庭用 以外（事務所、店鋪、病院等業務用 ）に 使用された場合の故障及び損傷</li>
                  <li>・本書のご提示がない場合</li>
                  <li>・家具本体にかか わるシーリング処理</li>
                  <li>・展示品を転売された場合</li>
                  <li>・保証書にお引き渡し年月日、お客様名、販売店名の記入のない場合（領収書等で左記内容がわかる場合はその限り ではありません）、 あるいは字句を書き替えられた場合</li>
                  <li>・離島または離島 に準じる遠隔地 へ出張修理を行う場合の出張 に要する実費</li>
                </ul>
              </div>
            </li>
            <li class="input_list" @click="selectOpenCancel()">
              <h3 v-bind:class="{Q_open: isOpenCancel, Q_close: !isOpenCancel}">Q.&nbsp;注文をキャンセルしたい・商品を返品したい</h3>
              <div v-show="isOpenCancel">
                <h4>A.</h4>
                <p>オーダー品となる為、購入後の商品のキャンセルは承っておりません。
                お届けした商品が注文した商品と異なる場合は、<router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご報告ください。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenService()">
              <h3 v-bind:class="{Q_open: isOpenService, Q_close: !isOpenService}">Q.&nbsp;組立設置サービスについて</h3>
              <div v-show="isOpenService">
                <h4>A.</h4>
                <p>ご購入いただいた家具の組立・設置を、組立専門業者が行うサービスです。</p>
                <p>■サービスの流れ</p>
                <ul>
                  <li>①ご注文の際に、組み立て作業の有無を選択いただき、作業希望日を入れていただきます。</li>
                  <li>(作業希望日は、商品到着予定の3日以降よりご指定ください)</li>
                  <li>②ご注文完了後、組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。</li>
                  <li>③ご指定の場所にお伺いし、組立作業をいたします。</li>
                  <li>④作業後は周辺を清掃し、梱包材を回収します。</li>
                  <li>⑤作業終了後、ご確認&amp;検収サインをいただきます。</li>
                </ul>
                <br>
                <p>■組立指定業者：キャンディルグループ</p>
                <ul>
                  <li>（㈱キャンディルテクト、㈱バーンリペア)</li>
                  <li>URL：https://www.candeal.co.jp/</li>
                  <li>キャンディルグループでは、大手北欧家具メーカーや、国内有名メーカーなどの家具組み立てを行っております。</li>
                  <li>経験・知識が豊富なスペシャリストが対応しますので、スピーディーな作業が可能です。安心してお任せください。</li>
                </ul>
                <br>
                <p>■家具組立設置サービス詳細に関するお問い合わせ</p>
                <ul>
                  <li>・メール … mmstyle.te@candeal.co.jp</li>
                  <li>・お電話 … 03-5625-3095(9:00～18:00)</li>
                </ul>
              </div>
            </li>
            <li class="input_list" @click="selectOpenConstructPrice()">
              <h3 v-bind:class="{Q_open: isOpenConstructPrice, Q_close: !isOpenConstructPrice}">Q.&nbsp;組立設置料金について</h3>
              <div v-show="isOpenConstructPrice">
                <h4>A.</h4>
                <p>ご購入いただいた家具に応じて組立設置料金が反映されます。<br></p>
                <p>(組立設置オプションには、以下の費用が発生します。</p>
                <p>組立技術料：組立作業費および副資材、簡易養生材など</p>
                <p>諸経費：交通費(エリアにより異なる)、燃料代など)</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenConstructDate()">
              <h3 v-bind:class="{Q_open: isOpenConstructDate, Q_close: !isOpenConstructDate}">Q.&nbsp;組立設置作業日について</h3>
              <div v-show="isOpenConstructDate">
                <h4>A.</h4>
                <p>ご注文の際に、組立設置の作業希望日をお知らせいただきます。(第3希望まで)</p>
                <p>※作業希望日は、商品到着予定の、3日以降よりご指定ください。</p>
                <p>組立業者(キャンディルグループ)より、日程調整のご連絡(メール又はお電話)をいたします。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenConstructTime()">
              <h3 v-bind:class="{Q_open: isOpenConstructTime, Q_close: !isOpenConstructTime}">Q.&nbsp;組立設置(訪問)の時間について</h3>
              <div v-show="isOpenConstructTime">
                <h4>A.</h4>
                <p>訪問当日に、具体的な訪問時間をご連絡します。</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenPrecaution()">
              <h3 v-bind:class="{Q_open: isOpenPrecaution, Q_close: !isOpenPrecaution}">Q.&nbsp;組立設置の注意事項/お願い</h3>
              <div v-show="isOpenPrecaution">
                <h4>A.</h4>
                <p>■訪問日前までに</p>
                <ul>
                  <li>・作業スタッフが組み立てにお伺いする前に、お客様にて破損・不良がないかご確認をお願いいたします。</li>
                  <li>・スペースの確保をお願いいたします。</li>
                  <li>  ※作業を行うスペースの確保が難しい場合、予めご申告お願いいたします。</li>
                  <li>・家具を設置スペースに運んでいただけますと幸いです</li>
                </ul>
                <br>
                <p>■作業当日</p>
                <ul>
                  <li>・作業開始前と終了時に、作業における確認をお願いしております。ご協力のほどよろしくお願いいたします。</li>
                  <li>・作業により、電源をお借りする場合があります。あらかじめご了承ください。</li>
                </ul>
                <br>
                <p>■その他の注意事項に関しては、利用規約をご確認ください</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenOrderCancel()">
              <h3 v-bind:class="{Q_open: isOpenOrderCancel, Q_close: !isOpenOrderCancel}">Q.&nbsp;組立設置のキャンセルについて</h3>
              <div v-show="isOpenOrderCancel">
                <h4>A.</h4>
                <ul>
                  <li>・ご注文後のキャンセルは、お受けいたしかねます。</li>
                  <li>  (返金いたしかねますので、ご了承ください)</li>
                  <li>&nbsp;※なお、日程変更は、なるべく作業予定日の3日前までにお電話にてご連絡ください。</li>
                </ul>
                <br>
                <p>■家具組立設置サービス詳細に関するお問い合わせ</p>
                <ul>
                  <li>キャンディルグループ</li>
                  <li>メール&nbsp;…&nbsp;mmstyle.te@candeal.co.jp</li>
                  <li>お電話&nbsp;…&nbsp;03-5625-3095&nbsp;(9:00～18:00)</li>
                </ul>
              </div>
            </li>
            <li class="input_list" @click="selectOpenUserUpdate()">
              <h3 v-bind:class="{Q_open: isOpenUserUpdate, Q_close: !isOpenUserUpdate}">Q.&nbsp;会員情報を変更したい</h3>
              <div v-show="isOpenUserUpdate">
                <h4>A.</h4>
                <p>登録情報確認ページより編集することができます。</p>
              </div>
            </li>
            <li v-if="false" class="input_list" @click="selectOpenWithDrawl()">
              <h3 v-bind:class="{Q_open: isOpenWithDrawl, Q_close: !isOpenWithDrawl}">Q.&nbsp;退会したい</h3>
              <div v-show="isOpenWithDrawl">
                <h4>A.</h4>
                <p>・退会手続き</p>
              </div>
            </li>
            <li class="input_list" @click="selectOpenOther()">
              <h3 v-bind:class="{Q_open: isOpenOther, Q_close: !isOpenOther}">Q.&nbsp;そのほかのお問い合わせ</h3>
              <div v-show="isOpenOther">
                <h4>A.</h4>
                <p>ご不明なことがございましたら、<router-link to="/mmstyle/support/input">お問合わせフォーム</router-link>よりご連絡ください。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from '../components/common/DcHeader'

export default {
  name: 'faq',
  components: {
    'dd-header': Header
  },
  data () {
    return {
      isOpenItem: false,
      isOpenFiller: false,
      isOpenDelivery: false,
      isOpenDeliImposible: false,
      isOpenPayment: false,
      isOpenTransition: false,
      isOpenSetting: false,
      isOpenGuarantee: false,
      isOpenCancel: false,
      isOpenConstruct: false,
      isOpenUserUpdate: false,
      isOpenWithDrawl: false,
      isOpenOther: false,
      isOpenService: false,
      isOpenConstructPrice: false,
      isOpenConstructDate: false,
      isOpenConstructTime: false,
      isOpenPrecaution: false,
      isOpenOrderCancel: false
    }
  },
  methods: {
    selectOpenItem: function () {
      this.isOpenItem = !this.isOpenItem
    },
    selectOpenFiller: function () {
      this.isOpenFiller = !this.isOpenFiller
    },
    selectOpenDelivery: function () {
      this.isOpenDelivery = !this.isOpenDelivery
    },
    selectOpenDeliImposible: function () {
      this.isOpenDeliImposible = !this.isOpenDeliImposible
    },
    selectOpenPayment: function () {
      this.isOpenPayment = !this.isOpenPayment
    },
    selectOpenTransition: function () {
      this.isOpenTransition = !this.isOpenTransition
    },
    selectOpenSetting: function () {
      this.isOpenSetting = !this.isOpenSetting
    },
    selectOpenGuarantee: function () {
      this.isOpenGuarantee = !this.isOpenGuarantee
    },
    selectOpenCancel: function () {
      this.isOpenCancel = !this.isOpenCancel
    },
    selectOpenConstruct: function () {
      this.isOpenConstruct = !this.isOpenConstruct
    },
    selectOpenUserUpdate: function () {
      this.isOpenUserUpdate = !this.isOpenUserUpdate
    },
    selectOpenWithDrawl: function () {
      this.isOpenWithDrawl = !this.isOpenWithDrawl
    },
    selectOpenOther: function () {
      this.isOpenOther = !this.isOpenOther
    },
    selectOpenService: function () {
      this.isOpenService = !this.isOpenService
    },
    selectOpenConstructPrice: function () {
      this.isOpenConstructPrice = !this.isOpenConstructPrice
    },
    selectOpenConstructDate: function () {
      this.isOpenConstructDate = !this.isOpenConstructDate
    },
    selectOpenConstructTime: function () {
      this.isOpenConstructTime = !this.isOpenConstructTime
    },
    selectOpenPrecaution: function () {
      this.isOpenPrecaution = !this.isOpenPrecaution
    },
    selectOpenOrderCancel: function () {
      this.isOpenOrderCancel = !this.isOpenOrderCancel
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  }
}
</script>
<style src="../css/faq.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/Faq.vue